import { Box, CardMedia, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import usePortalStyles from '../../../layouts/PortalLayout/usePortalStyles';
import usePublic from '../../../utilities/usePublic';

const LoginTitle = () => {
    const portalStyles = usePortalStyles();
    const { t } = useTranslation(['loginPage']);
    const image = usePublic('assets/images/rollsRoyce.png');
    const theme = useTheme();

    const isSmall = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <Grid xs={12} item>
            <Box mb={isSmall ? 12 : 4} position="relative">
                <CardMedia className={portalStyles.carMedia} image={image} />
                <Typography className={portalStyles.signUpLabel}>{t('loginPage:title')}</Typography>
            </Box>
        </Grid>
    );
};

export default LoginTitle;
